import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import styled, { css } from "styled-components";

import { DefaultTheme } from "../../slate/Theme";

export const CentralIconWrapper = styled(Column).attrs({
  align: "center",
  justify: "center",
})<{ $color: string; $defaultHidden?: boolean }>`
  position: absolute;
  top: 50%;
  left: 50%;
  width: calc(100% - ${getSpacing("2x")});
  transform: translate(-50%, -50%);
  color: ${(props) => props.$color};

  ${({ $defaultHidden: defaultHidden }) =>
    defaultHidden
      ? // eslint-disable-next-line @faire/prefer-slate-attrs -- use ResponsiveContentV2
        css`
          display: none;
        `
      : null}
`;

export const DropzoneContainer = styled(Column).attrs({
  align: "center",
  justify: "center",
})<{
  $height: number;
  $width?: number;
  $uploadError: boolean;
  $circleImage?: boolean;
  /**
   * prop for if the click (ie. dropzone browse) functionality is externally managed
   */
  $externallyManagedClicks?: boolean;
}>`
  position: relative;
  width: ${({ $width: width }) =>
    width
      ? css`
          ${width}px
        `
      : css`100%`};
  height: ${({ $height: height }) => height}px;
  background-color: ${({ $uploadError: uploadError }) =>
    uploadError ? Core.surface.critical : DefaultTheme.surface.subdued};
  outline: 1px dashed ${Core.border.subdued};
  outline-offset: -8px;
  ${({ $circleImage: circleImage }) =>
    circleImage
      ? css`
          border-radius: 50%;
          outline: none;

          div {
            border-radius: 50%;
          }
        `
      : null}
  ${({ $externallyManagedClicks: externallyManagedClicks = false }) =>
    externallyManagedClicks
      ? null
      : // eslint-disable-next-line @faire/prefer-slate-attrs -- do not overwrite flex
        css`
          &:hover {
            img {
              filter: brightness(50%);
            }

            ${CentralIconWrapper} {
              display: flex;
            }
          }
          cursor: pointer;
        `};

  img {
    height: 100%;
    width: 100%;
    ${({ $circleImage: circleImage }) =>
      circleImage
        ? css`
            border-radius: 50%;
          `
        : null}
    object-fit: cover;
    object-position: center;
    filter: brightness(100%);
    background: ${Core.surface.inverse};
  }
`;

export const MaxSizeDiv = styled.div`
  max-height: 100%;
  max-width: 100%;
  height: 100%;
  width: 100%;
`;
